import { getAllManufacturers, getManufacturers } from "../../../utils/apiRequests"
import useGetAllPaginatedItemsLegacy from "../useGetAllPaginatedItems";
import useResponse, { useResponseLegacy } from "../useResponse";

export const useManufacturers = (dependency = null) => {
    const {rows:data, status} = useResponse<any[]>({requestFunction:getManufacturers,values:null, requestNothingOnNull:false, dependency});
    return {data, status};
}

// export const useManufacturers = (dependecy = null) => {
//     const response = useGetAllPaginatedItems<any>(getAllManufacturers, 500,["Manufacturer","Key"]);
//     return response;
// }